import { memo } from "react";
import { cn } from "src/utilities/shadcnUtils";

export interface DividerProps {
  className?: string;
  lineClassName?: string;
}

const Divider = ({ className, lineClassName }: DividerProps) => (
  <div className={cn("w-full flex justify-center items-center", className)}>
    <div className={cn("h-px bg-gray-400 w-full", lineClassName)} />
  </div>
);

export default memo(Divider);
